import {IPaylodAction} from '../interfaces/dispatchers'
import {IPopups} from '../interfaces/reducers'
import PopupActions from '../enums/ActionTypes/PopupActions'

const initState = {popupSettings: {}} as IPopups
const application = (state: IPopups = initState, action: IPaylodAction) => {
  switch (action.type) {
    case PopupActions.ADD_POPUPS:
      return {popupSettings: {...state.popupSettings, ...action.payload}}
    case PopupActions.REMOVE_POPUPS:
      const popupsLeft = {...state.popupSettings}
      ;(action.payload as Array<string>).forEach(id => {
        delete popupsLeft[id]
      })
      return {popupSettings: popupsLeft}
    default:
      return state
  }
}
export default application
